// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"27f94d26","239":"3c39e2f8","378":"09f0906b","455":"ce1759fc","672":"14de182e","793":"13f3439f"}[chunkId] + ".chunk.js";
};